import * as React from 'react';
import Editor, { loader } from '@monaco-editor/react';

interface IProps {
    language: string;
    value?: string;
    callbacOnChange?: Function;
    callbackOnUnmount?: Function;
    options?: any;
    callbackOnDidmount?: Function;
}
interface IState {
    value?: string;
}

class MonacoEditor extends React.PureComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        loader.config({ paths: { vs: '/ixyber/vision/vs' } });

        if (this.props.callbacOnChange != undefined) {
            this.props.callbacOnChange(null);
        }

        this.state = { value: props.value };
    }

    componentWillUnmount() {
        if (this.props.callbacOnChange != undefined) {
            this.props.callbacOnChange(null);
        }

        this.props.callbackOnUnmount && this.props.callbackOnUnmount();
    }

    componentWillReceiveProps(nextProps: IProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.value !== this.state.value) {
            this.setState({ value: nextProps.value });
            if (this.props.callbacOnChange != undefined) {
                this.props.callbacOnChange(null);
            }
        }
    }

    editorWillMount(monaco: any) {
        console.log('asd');
        monaco.languages.typescript.typescriptDefaults.addExtraLib(
            [
                ' HDAServer:any  = {',
                ' static AggregatesAsync(id: string, nameFun: string, starttimeiso: any, endtimeiso: any, resample: number)',
                ' static ReadAtTimeAsync(Items: string[], TimeArray: any[])',
                ' static ReadRawFilterAsync(ids: string[], starttimeiso: any, endtimeiso: any, boundaryType: string = "Auto", filterType: string = "Any")',
                '}',

                '}'
            ].join('\n'),
            'd.ts'
        );
    }

    editorDidMount(editor: any, monaco: any) {
        editor.focus();
    }

    render() {
        let Value: string = this.state.value == undefined ? '' : this.state.value;
        let Options: any =
            this.state.value == undefined
                ? {
                      lineNumbersMinChars: 0,
                      overviewRulerBorder: false
                  }
                : this.props.options;

        return (
            <React.Fragment>
                <Editor
                    language={this.props.language}
                    value={Value}
                    options={Options}
                    onChange={(newValue: any, e: any) => {
                        if (this.props.callbacOnChange != undefined) {
                            this.props.callbacOnChange(newValue);
                        }
                    }}
                    onMount={(editor: any, monaco: any) => {
                        if (this.props.callbackOnDidmount != undefined) {
                            this.props.callbackOnDidmount(editor, monaco);
                        }
                    }}
                />
            </React.Fragment>
        );
    }
}

export default MonacoEditor;
